import { z } from 'zod';
import type {
  BulkDeleteTaxonomyCategoriesResult,
  DeleteTaxonomyCategoryResult,
  TaxonomyCategory,
} from '../model/types';

export const taxonomyCategorySchema: z.ZodType<TaxonomyCategory> = z.looseObject({
  id: z.string(),
  name: z.string(),
  icon: z.string().nullable(),
  sortOrder: z.number(),
  orgWide: z.boolean(),
  fieldCount: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const taxonomyCategoryListSchema = z.array(taxonomyCategorySchema);

export const deleteTaxonomyCategorySchema: z.ZodType<DeleteTaxonomyCategoryResult> = z.looseObject({
  movedFieldCount: z.number(),
  movedTo: z.string().nullable(),
});

export const bulkDeleteTaxonomyCategoriesSchema: z.ZodType<BulkDeleteTaxonomyCategoriesResult> =
  z.looseObject({
    movedFieldCount: z.number(),
    movedTo: z.string().nullable(),
    deletedIds: z.array(z.string()),
  });
